import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || window.location.origin;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('apex_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('apex_token');
      window.location.href = '/admin';
    }
    return Promise.reject(err);
  }
);

export default api;
